module.exports = __webpack_public_path__ + "img/banner-01.0e4b47d8.jpg";